module.exports = __webpack_public_path__ + "img/pfc-ludogorets-razgrad.005bc0f6.png";